import { Attrs, EventListeners, MinzeElement, Reactive } from 'minze'
import { Font } from '../../../constants'
import { Callback } from '../../../modules/callback'

interface InputFieldChangeEvent {
  fieldId: string
  value: string
  mobileLabelCentered: boolean
}

export class LvcCheckbox extends MinzeElement {
  reactive: Reactive = [['checked', false, true]]

  attrs: Attrs = [
    'name',
    'label',
    ['default-value', ''],
    'mobile-label-centered',
    ['secondary-style', false],
    'on-change',
    'error',
  ]
  id: string = Math.random().toString(36).substr(2, 9)

  static observedAttributes = ['name', 'default-value', 'error']

  onAttributeChange(
    name?: string | undefined,
    oldValue?: string | null | undefined,
    newValue?: string | null | undefined
  ): void | Promise<void> {
    if (name === 'default-value') {
      this.updateDefaultValue()
    }
  }

  async updateDefaultValue() {
    const value = this.getAttribute('default-value')
    this.checked = value === 'true'
    this.rerender()
  }

  html() {
    let showError = typeof this.error === 'string' && this.error.length > 0
    return `
      <lvc-box display="flex" alignItems="center">
        <input
          type="checkbox"
          id="${this.id}"
          name="${this.name}"
          ${this.checked ? `checked` : ''}
          class="checkbox"
        />
        <label for="${this.id}" class="checkbox-label">
          ${this.label}
        </label>
      
      </lvc-box>
      ${showError ? `<lvc-error error="${this.error}"></lvc-error>` : ''}
    `
  }

  css = () => `
    :host {
      width: 100%;
    }

    .checkbox:checked::after {
      content: '✓';
      color: #1E007D;
      display: block;
      width: 100%;
      height: 100%;
      line-height: 1;
    }

    .checkbox {
      border-radius: 2px;
      text-align: center;
      appearance: none;
      border: 1px solid #1E007D;
      height: 16px;
      min-height: 16px;
      max-height: 16px;
      width: 16px;
      min-width: 16px;
      max-width: 16px;
      display: block;
      position: relative;
      font-size: 16px;
      line-height: 1px;
      background: transparent;
      color: transparent;
      cursor: pointer;
    }

    label {
      font-family: ${Font.family};
      font-size: 14px;
      color: #1E007D;
      margin-left: 12px;
    }

    a:hover {
      color: #FFF;
    }
    
    @media screen and (max-width: 730px) {
      ${
        this.mobileLabelCentered
          ? `
        label {
          width: 100%;
          text-align: center;
          margin-left: 0;
        }
      `
          : ``
      }
    }
    
    ${
      this.secondaryStyle
        ? `
      .checkbox {
        height: 24px;
        min-height: 24px;
        max-height: 24px;
        width: 24px;
        min-width: 24px;
        max-width: 24px;
      }
      .checkbox:checked::after {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      label {
        font-weight: 500;
        margin-left: 5px;
      }
    `
        : ''
    }
  `

  handleInput(event: Event) {
    this.checked = (event.target as HTMLInputElement)?.checked
    Callback.call(this.onChange as string, this.checked)
    this.rerender()
  }

  eventListeners: EventListeners = [['input', 'change', this.handleInput.bind(this)]]
}
